<template>
  <v-dialog v-model="is_MessageDetailSettingModal" max-width="980">
    <v-card class="message-detail-setting">
      <v-card-title class="pt-5 pl-5 pb-1 font-weight-bold"> 메시지 설정 - {{ msg_type_text }}</v-card-title>

      <v-card-text class="pl-5 pb-0">
        {{ msg_description }}
      </v-card-text>
      <v-tabs
        class="mt-6 pt-0 px-5 pb-5 col-12 justify-space-between message-group"
        :class="{ 'two-tabs': !isAllowedKakao, 'three-tabs': isAllowedKakao }"
        centered
        hide-slider
        v-model="activeTab"
        active-class="grey darken-1 white--text"
      >
        <v-tab class="setting-tab" v-if="isAllowedKakao">
          카카오톡
        </v-tab>
        <v-tab-item v-if="isAllowedKakao">
          <KakaoDetailSetting
            ref="KakaoDetailSetting"
            :msg_type="msg_type"
            :msg_title="msg_type_text"
            :is_manual="isManualMessageType"
            @close="closeModal"
          ></KakaoDetailSetting>
        </v-tab-item>
        <v-tab class="setting-tab">SMS</v-tab>
        <v-tab-item>
          <SmsDetailSetting
            ref="SmsDetailSetting"
            :msg_type="msg_type"
            :msg_title="msg_type_text"
            :is_manual="isManualMessageType"
            @close="closeModal"
          ></SmsDetailSetting>
        </v-tab-item>
        <v-tab class="setting-tab">이메일</v-tab>
        <v-tab-item>
          <EmailDetailSetting
            ref="EmailDetailSetting"
            :msg_type="msg_type"
            :is_manual="isManualMessageType"
            @close="closeModal"
          ></EmailDetailSetting>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-dialog>
</template>
<style>
.message-detail-setting .setting-tab {
  border: 1px solid #dadada;
  border-radius: 4px;
  height: 30px;
  font-size: 1em !important;
  width: 100%;
  margin: 0 !important;
}

.message-group .v-slide-group__content {
  gap: 8px;
}

/* 3개 탭일 때 (카카오톡 포함) */
.message-detail-setting .three-tabs .setting-tab {
  flex: 1;
  max-width: calc(33.333% - 7px);
  min-width: 120px;
}

/* 2개 탭일 때 (카카오톡 제외) */
.message-detail-setting .two-tabs .setting-tab {
  flex: 1;
  max-width: calc(50% - 6px);
  min-width: 150px;
  gap: 8px;
}

/* 탭 컨테이너 전체 너비 사용 */
.message-detail-setting .v-tabs-bar {
  width: 100%;
  display: flex;
}

.message-detail-setting .v-tabs-bar .v-tabs-slider-wrapper {
  display: none;
}

.message-detail-setting .text-xs {
  font-size: 12px;
}

.message-detail-setting label {
  font-size: unset !important;
}
</style>

<script>
import KakaoDetailSetting from "@/components/authservice/message/modal/KakaoDetailSetting.vue";
import SmsDetailSetting from "@/components/authservice/message/modal/SmsDetailSetting.vue";
import EmailDetailSetting from "@/components/authservice/message/modal/EmailDetailSetting.vue";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      activeTab: 0,
      is_MessageDetailSettingModal: false,
      msg_type_text: null,
      msg_description: null,
      msg_type: null,
    };
  },
  created: function() {
    // console.log("msg detail view created");
  },
  computed: {
    isAllowedKakao() {
      return this.isAllowedKakaoForDigital();
    },
    isManualMessageType() {
      return this.isManualMessage(this.msg_type);
    },
  },
  methods: {
    resetSetting: function() {
      // console.log("resetSetting all check", this.msg_type);
      this.activeTab = 0;
      /*
      if (this.$refs.KakaoDetailSetting) {
        this.$refs.KakaoDetailSetting.resetKakaoDetailSetting();
      }
      if (this.$refs.SmsDetailSetting) {
        this.$refs.SmsDetailSetting.resetSmsDetailSetting();
      }
      if (this.$refs.EmailDetailSetting) {
        this.$refs.EmailDetailSetting.resetEmailDetailSetting(this.msg_type);
        console.log("detail check email", this.$refs.EmailDetailSetting.msg_type);
      }
        */
    },
    closeModal() {
      // console.log("call smsCloseModal");
      this.is_MessageDetailSettingModal = false;
    },
    openMessageDetailSettingModal(info) {
      // console.log("open Modal input info", info);
      this.msg_type = info.msg_type;
      this.msg_type_text = info.title.replace("<br/>", " ");
      this.msg_description = info.description.replace(/<br\/>/g, " ");
      this.is_MessageDetailSettingModal = true;
      // console.log("open check 1", this.$refs, this.$refs.KakaoDetailSetting, this.msg_type);
      this.resetSetting();
    },
  },
  components: {
    KakaoDetailSetting,
    SmsDetailSetting,
    EmailDetailSetting,
  },
};
</script>
